import currencyFormatter from '@/shared/lib/currency-formatter'
import { find, some } from 'lodash'

export default {
  data () {
    return {
      legacyProductOptionSubTotal: 0.00,
      subTotal: null
    }
  },
  created () {
    document.addEventListener('package.subTotalUpdated', e => {
      this.legacyProductOptionSubTotal = e.detail.subtotal
      this.calculateSubtotal()
    })

    document.addEventListener('package.quantityUpdated', e => {
      this.$store.commit('updatePackageQuantity', e.detail.quantity)
    })

    const quantityInputs = document.getElementsByName('ddlQuantity')

    if (quantityInputs && quantityInputs.length > 0) {
      const initialQuantity = parseInt(quantityInputs[0].value, 10)
      this.$store.commit('updatePackageQuantity', initialQuantity)
    }
  },
  computed: {
    showInlineUpgrade () {
      return this.offerPackage.UpgradePackageId !== null && this.offerPackage.CmsUpgradeOfferPackageDetailId !== null
    },
    selectedOptionProducts () {
      return this.$store.state.optionProducts.selectedOptionProducts
    },
    currentCultureNumberFormat () {
      return this.$store.state.catalogPageCommon.currentCultureNumberFormat
    },
    currency () {
      return this.$store.state.catalogPageCommon.currency
    },
    packageQuantity () {
      return this.$store.state.catalogPageCommon.packageQuantity
    }
  },
  watch: {
    legacyProductOptionSubTotal (v, ov) {
      this.calculateSubtotal()
    },
    selectedOptionProducts (v, ov) {
      this.calculateSubtotal()
    }
  },
  methods: {
    calculateSubtotal () {
      const primaryPackageSubtotal = this.offerPackage.EffectiveCost * this.packageQuantity
      const finalTotal = primaryPackageSubtotal + this.legacyProductOptionSubTotal + this.$store.getters.subTotalSelectedOptionProducts

      this.subTotal = currencyFormatter.format(finalTotal, this.currentCultureNumberFormat, this.currency)
    },
    optionHasPreviewModal (catalogPackageOptionId) {
      let packageOption = find(this.packageOptions.ListableOptions, { CatalogPackageOptionID: catalogPackageOptionId })

      if (packageOption) {
        let hasGroupDetail = packageOption.CmsOptionGroupDetail !== null

        let hasOptionDetail = some(packageOption.OptionProducts, (op) => {
          return op.CmsProductDetail !== null
        })

        return hasGroupDetail && hasOptionDetail
      }

      return false
    },
    getPackageOptionById (catalogPackageOptionId) {
      return find(this.packageOptions.ListableOptions, { CatalogPackageOptionID: catalogPackageOptionId })
    },
    getPackageOptionProductById (catalogPackageOptionId, catalogPackageOptionProductID) {
      const option = find(this.packageOptions.ListableOptions, { CatalogPackageOptionID: catalogPackageOptionId })

      return find(option.OptionProducts, { CatalogPackageOptionProductID: catalogPackageOptionProductID })
    }
  }
}



// WEBPACK FOOTER //
// ./WebResources/vue/shared/mixins/catalog-pages.js